














































































































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, ref, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { User, Room } from "../../modules/teacher/TeacherList"

interface Data {
  currentUser: any;
  users: User[];
  errors: string[];
  condition: {
    role: string,
    curriculum_id: string,
    name: string,
  };
  isAllCheckedPassword: boolean;
  isAllCheckedDelete: boolean;
  isAllCheckedActive: boolean;
  password_ids: number[];
  delete_ids: number[];
  rooms: Room[];
  modalUser: User;
  accessibleRoomCodes: number[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    const modalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      currentUser: context.root.$store.state.currentUser,
      users: [],
      errors: [],
      condition: {
        role: "",
        curriculum_id: "",
        name: ""
      },
      isAllCheckedPassword: false,
      isAllCheckedDelete: false,
      isAllCheckedActive: false,
      password_ids: [],
      delete_ids: [],
      rooms: [],
      modalUser: null,
      accessibleRoomCodes: [],
    });

    /******************************
     * computed
     ******************************/

    


    /******************************
     * methods
     ******************************/

    const clearCondition = (): void => {
      state.condition.role = "";
      state.condition.curriculum_id = "";
      state.condition.name = "";
    }

    /**
     * ユーザ一覧検索処理
     */
    const searchUsers = async (): Promise<void> => {

      context.root.$store.dispatch("showOverlay", `データ取得中... しばらくお待ちください。`);

      state.errors = [];
  
      await http.get(`/api/teacher_list?${Common.BuildQuery(state.condition, 'search_user')}`).then(response => {

        // 検索結果設定
        state.users = response.data.users.map((x: any) => new User(x, context.root.$store.state.curriculums));
        state.rooms = response.data.rooms;

        /* ** 初期化 ** */
        state.password_ids = [];
        state.delete_ids = [];
        state.isAllCheckedPassword = false;
        state.isAllCheckedDelete = false;
        state.isAllCheckedActive = false;
      })
      .catch(error => {

        if (error.response.status == 422) {
          state.errors = error.response.data.errors;
        } else {
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * パスワード再設定、メール送信処理
     */
    const sendResetMail = async (): Promise<void> => {

      if (!state.password_ids.length) {
        alert(`再設定通知を送る教師をチェックしてください。`);
        return;
      }

      if (!confirm(`本当にパスワード再設定を行ってもよろしいですか？再設定を行うと現在のパスワードが更新されます。`)) {
        return;
      }
      
      if (state.password_ids.includes(context.root.$store.state.currentUser.id)) {
        if (!confirm(`ログイン者もパスワード再設定対象ですが再設定してよろしいでしょうか？`)) {
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher_list/send_reset_mail`, {ids: state.password_ids}).then(response => {
        alert(`メールアドレスにパスワードを送信しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * ユーザ削除処理
     */
    const usersDelete = async (): Promise<void> => {

      if (!state.delete_ids.length) {
        alert(`削除する教師をチェックしてください。`);
        return;
      }

      if (!confirm(`本当に削除してよろしいでしょうか？`)) {
        return;
      }

      if (state.delete_ids.includes(context.root.$store.state.currentUser.id)) {
        if (!confirm(`ログイン者も削除対象ですが削除してよろしいでしょうか？`)) {
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher_list/delete_users`, {ids: state.delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 権限保存処理
     */
    const updateAuth = async (): Promise<void> => {

      if (!confirm(`権限を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher_list/update_auth`, {users: state.users}).then(response => {
        alert(`権限の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 教科保存処理
     */
    const updateCurriculum = async (): Promise<void> => {

      if (!confirm(`教科を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher_list/update_curriculum`, {users: state.users}).then(response => {
        alert(`教科の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 有効/無効状態処理
     */
    const updateUserActive = async (): Promise<void> => {

      if (!confirm(`有効/無効状態を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher_list/update_active`, {users: state.users}).then(response => {
        alert(`有効/無効状態の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    /**
     * 教室アクセス権モーダル表示
     */
    const showRoomsModal = (user: User): void => {
      state.modalUser = user;
      state.accessibleRoomCodes = user.user_rooms.map(m => m.room_code);
      modalRef.value.show();
    }

    /**
     * 教室アクセス権の保存処理
     */
    const updateAccessRooms = async (): Promise<void> => {

      if (!confirm(`アクセス権情報を更新します。よろしいですか？`)) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      // room_code順にソートしてupdate
      state.accessibleRoomCodes.sort();

      await http.post(`/api/teacher_list/update_access_room`, {user: state.modalUser, accessibleRoomCodes: state.accessibleRoomCodes}).then(response => {
        alert(`アクセス権情報の更新が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      modalRef.value.hide();
      context.root.$store.dispatch("hideOverlay");

      searchUsers();
    }

    const getConvertDate = (date: string, format: string): string => {
      if (!date) {
        return "-";
      }

      return Common.formatDate(date, format);
    }

    const getRoomNameByCode = (room_code: number): string => {
      const rooms = state.rooms.filter(x => x.room_code == room_code);
      return rooms.length > 0 ? rooms[0].name : "";
    };

    const checkScoringAuth = (index: number): void => {
      if (state.users[index].scoring_auth) {
        state.users[index].pending_scoring_auth = false;
      }
    }

    const checkPendingAuth = (index: number): void => {
      if (!state.users[index].pending_scoring_auth) {
        state.users[index].scoring_auth = true;
      }
    }

    const to = (path: string, query: {[key: string]: string}): void => {

      if (query == null) {
        context.root.$router.push({path: path}).catch(err => {});
      } else {
        context.root.$router.push({path: path, query: query}).catch(err => {});
      }
    }


    /******************************
     * created
     ******************************/
    
    searchUsers();

    /******************************
     * watch
     ******************************/

    watch(() => state.isAllCheckedPassword, (newVal, oldVal) => {

      state.password_ids = [];

      if (newVal) {

        state.password_ids = state.users.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {

        state.delete_ids = state.users.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedActive, (newVal, oldVal) => {
      state.users.forEach(x => x.is_active = newVal);
    });

    return {
      ...toRefs(state),
      modalRef,
      clearCondition,
      searchUsers,
      sendResetMail,
      usersDelete,
      updateAuth,
      showRoomsModal,
      updateAccessRooms,
      getConvertDate,
      getRoomNameByCode,
      checkScoringAuth,
      checkPendingAuth,
      to,
      updateCurriculum,
      updateUserActive,
    };
  },
})
